module.exports = __webpack_public_path__ + "img/771A1F_D2939E_B6595D_9D4B54-256px.2426d458.png";